// ============================================================================
// equipment.fueling.form — migrated off the global read
// ============================================================================
// The per-machine fueling form at /equipment/<slug>. TWO permanent owners,
// because it has two structurally different reads:
//
//   equipment.fuelingHub.core     the shared container load it renders FROM
//                                 (`equipment` prop + `equipmentList`), owned
//                                 jointly with the hub.
//   equipment.fuelingForm.history the machine's prior fuelings, keyed on
//                                 equipmentId so a machine switch is a KEY
//                                 CHANGE and a late response for the previous
//                                 machine can never drive this one's
//                                 due-interval projection.
//
// Two owners for two obligations is the rule holding, not bending: the
// one-owner rule forbids two owners for ONE obligation.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'equipment.fueling.form',
  obligations: Object.freeze([
    Object.freeze({id: 'equipment.fuelingHub.core', owner: 'permanent'}),
    Object.freeze({id: 'equipment.fuelingForm.history', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
